// Captured before LogRocket.init() wraps window.fetch: LogRocket's instrumentation
// buffers streamed response bodies, which breaks the chat's SSE stream.
// `src/init.ts` imports this module first so the capture happens before the
// wrap; any other importer only reads the already-captured value.
export const nativeFetch: typeof window.fetch = window.fetch.bind(window)
